import { Button } from '@mui/material';
import { useFourRContext } from './four-r-context.jsx';
import { useContext } from '../../context.jsx';

export function FourRButton() {
  const { tab, arePrescriptionsSelected } = useContext();
  const { setOpen } = useFourRContext();

  return tab === 'instances' ? null : (
    <Button disabled={!arePrescriptionsSelected} onClick={() => setOpen(true)}>
      4R Signature Page
    </Button>
  );
}
